<div class="label-content" [ngClass]="{ flip }" [ngStyle]="{ 'background-color': backgroundColor, color }">
  <ng-content></ng-content>
</div>
